module.exports = "/static/assets/aaa55abd17e010a1ec92e3285b9b9f1d.png";